import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emailToUserName' })
export class EmailToUserNamePipe implements PipeTransform {
  transform(email: string) {
    return email ? email.split('@')[0] : "";
  }
}
